import React, { ReactElement } from 'react';
import { graphql } from 'gatsby';
import { Spacer } from '@nooz-optics/nooz-components-lib';
import { MainLayout } from '../components/UI/Layout/Main/mainLayout';
import { BlogPost } from '../components/Blog/Post/blogPost';
import { Component } from '../components/Contentful/component';
import { MicroDataHelmet } from '../components/Utils/MicroData/Utils/microDataHelmet';
import { blogPostMicroData } from '../components/Utils/MicroData/BlogPost/blogPostMicroData';
import { returnLocalisedPath } from '../utils/globals';

export default ({ data, pageContext }): ReactElement => {
  const article = data?.contentfulBlogArticle;
  const { allLocalSlugs } = pageContext;
  const siteUrl = data?.site?.siteMetadata?.siteUrl;

  const {
    layout,
    seoMetadata,
    slug,
    title,
    subTitle,
    createdAt,
    components,
    node_locale,
  } = article;

  const locale = node_locale?.toLowerCase();
  const blogPostUrl = `${siteUrl}/${
    process.env.GATSBY_ZONE
  }${returnLocalisedPath(locale, slug?.url || '')}`;

  // SEO Micro Data
  const returnBlogPostMicroData = blogPostMicroData(
    blogPostUrl,
    title,
    subTitle,
    createdAt
  );

  return (
    <>
      <MicroDataHelmet schemaOrgJSONLD={returnBlogPostMicroData} />
      <MainLayout
        {...layout}
        page={{ seoMetadata, slug, title, allLocalSlugs }}>
        <BlogPost article={article} />
        {components && <Component {...components} />}
        <Spacer divider={{ space: 20 }} />
      </MainLayout>
    </>
  );
};

export const pageQuery = graphql`
  query BlogPostPageById($id: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    contentfulBlogArticle(id: { eq: $id }) {
      ...BlogArticlePageData
    }
  }
`;
